import styled from 'styled-components';

export const Row = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    margin-bottom: 20px;
`;

export const Tab = styled.div`
    display: flex;
    border-bottom: ${props => props.active ? '3px solid #Ec6E0C' : '#none'};
    margin-right: 24px;
    font-size: 20px;;
    color: ${props => props.active ? '#1A171B' : '#BDBDBF'};
    font-weight: bold;
    cursor: pointer;
`;

